import { SelectMode, SelectSettings } from '@rappider/rappider-components/utils';

export const SINGLE_NOT_SEARCHABLE_SELECT_SETTINGS: SelectSettings = {
  mode: SelectMode.Single,
  searchable: false
};
